import { Box, ColorOptions, Icon, Loader, ModBox, RadioButtonGroup, Spacer, Text } from '@jfs/ui-new'
import { TextInputNew } from '../../components/AdminInputs'
import { ButtonNew } from '../../components/AdminButton'
import { useEffect, useState } from 'react'
import { useLazyApiData, useStores } from '../../data/store'
import EntityOnboarding from './Onboarding'
import { styles } from './styles'

export const EmType = {
  createSingleEntity: 'createSingleEntity',
  createGroup: 'createGroup',
  createSubGroup: 'createSubGroup',
  createTid: 'createTid',
  createBulkEntries: 'createBulkEntries',
  Search: 'search',
  applicationQueue: 'applicationQueue',
  myQueue: 'myQueue',
  entityOnboarding: 'entityOnboarding',
}
const rbData = ['Entity Id', 'TID', 'Mobile Number', 'Device Serial No.']
const entityManageData = [
  'Create Single Entity',
  'Create Bulk Entities',
  'Sync Bulk Entities with MAS',
  'Whitelist Devices',
  'Bulk Program Creation',
  'Map Devices',
  'Create Bulk Config',
  'Create Bulk Cards',
  'FIU Compliance',
  'Aadhaar Redaction',
]
const headTitles = [
  { ID: 'ID' },
  { mas: 'MAS ID' },
  { name: 'Business Name' },
  { level: 'Level' },
  { mobile: 'Mobile Number' },
  { status: 'Status' },
]
const EntityManagement = () => {
  const { getEntityById } = useStores((store) => ({
    getEntityById: store.entityMaster.getEntity,
  }))

  const [onBoardingVisible, setOnBoardingVisible] = useState(false)
  const [searchString, setSearchString] = useState('5228')
  const [placeHolder, setPlaceholder] = useState('')
  const [searchLength, setSearchLength] = useState(-1)
  const [showButtons, setShowButtons] = useState(false)
  const [cancel, setCancel] = useState(false)

  const [error, setError] = useState('')
  const [isLoading, setLoading] = useState(false)

  const [callSearch, { data, state }] = useLazyApiData(getEntityById)

  // const regex = /^\d{15}$/
  const isValidEntry = searchString.length === searchLength

  useEffect(() => {
    if (!cancel && (state === 'fulfilled' || state === 'rejected')) {
      console.log('state', state, data)
      if (data.status === 'FAILED') {
        setError(data.message ?? 'Something went wrong! Try again later.')
      } else {
        setError('We couldn’t find any merchant with this MID, Would you like to onboard this merchant?')
      }
      setLoading(false)
      setShowButtons(state === 'fulfilled')
    }
  }, [cancel, data, state])

  const onSearchPress = () => {
    if (isValidEntry) {
      if (isLoading) {
        setLoading(false)
        setCancel(true)
      } else {
        setCancel(false)
        setLoading(true)
        setError('')
        callSearch(searchString)
      }
    } else {
      setError('Enter valid input as per selection')
    }
  }

  const rightComp = () => {
    return (
      <Box w={100}>
        <ModBox show={isLoading} {...styles.loadingContainer}>
          <Loader type={'small'} color={'#A0A0A0' as ColorOptions} />
          <Spacer size={8} direction={'horizontal'} />
          <Text title={'Searching...'} color={'#A0A0A0' as ColorOptions} fontSize={12} fontFamily={'jiotype-medium'} />
        </ModBox>
      </Box>
    )
  }

  const onRadioChange = (checkedName: string) => {
    setLoading(false)
    setCancel(false)
    setError('')
    setShowButtons(false)
    const getPlaceHolder = {
      'Entity Id': 'Search with Entity ID',
      TID: 'Search with TID',
      'Mobile Number': 'Search with Mobile Number',
      'Device Serial No.': 'Search with Device Serial No.',
    }
    const getSearchLength = {
      'Entity Id': 4,
      TID: 10,
      'Mobile Number': 10,
      'Device Serial No.': 12,
    }
    const str = getPlaceHolder[checkedName] ?? 'Search'
    setPlaceholder(str)
    const sLength = getSearchLength[checkedName]
    setSearchLength(sLength)
  }

  const entityItemPress = (entityName: string) => {
    console.log('entityItemPress', entityName)
    if (entityName === 'Create Single Entity') {
      setOnBoardingVisible(true)
    }
  }

  const handleNotNow = () => {
    setError('')
    setShowButtons(false)
  }

  const onCreateEntityPress = () => {
    setOnBoardingVisible(true)
    setError('')
    setShowButtons(false)
  }

  const onChangeText = (text: string) => {
    setSearchString(text)
    setError('')
    setShowButtons(false)
  }

  return (
    <Box {...styles.container}>
      <EntityOnboarding visible={onBoardingVisible} setVisible={setOnBoardingVisible} />
      <Text title={'Entity Management'} fontSize={18} color={'BLACK_21'} fontFamily={'jiotype-bold'} />
      <Box {...styles.innerContainer}>
        <Box {...styles.searchContainer}>
          <Text title={'Search Entity'} fontSize={18} color={'BLACK_21'} fontFamily={'jiotype-bold'} />
          <Spacer direction="vertical" size={16} />
          <RadioButtonGroup
            value={rbData[0]}
            data={rbData}
            textSize={12}
            size={16}
            fontFamily={'jiotype-medium'}
            textPadding={0}
            minItemHeight={36}
            horizontalGap={2}
            direction={'horizontal'}
            onChange={onRadioChange}
          />
          <Spacer direction="vertical" size={16} />
          <Box {...styles.textInputContainer(error.length > 0)}>
            <TextInputNew
              placeholder={placeHolder}
              paddingVertical={13}
              paddingHorizontal={16}
              value={searchString}
              maxLength={15}
              onChangeText={onChangeText}
              focusBorderColor={'TRANSPARENT'}
              rightComponent={rightComp()}
            />
            <ModBox onPress={onSearchPress} {...styles.iconContainer(true)} show={!error}>
              <Icon id={isLoading ? 'CLOSE' : 'SEARCH'} color={'WHITE'} size={20} />
            </ModBox>
          </Box>
          <ModBox show={!!error} maxWidth={240}>
            <Spacer size={16} direction={'vertical'} />
            <Text fontSize={12} color={'ERROR'} fontFamily={'jiotype-medium'}>
              {error}
            </Text>
          </ModBox>
          <Spacer size={24} direction={'vertical'} />
          <ModBox flexDirection={'row'} gap={16} show={showButtons}>
            <ButtonNew
              height={40}
              width={154}
              type={'primarySmall'}
              title={'Create Entity'}
              borderRadius={4}
              color={'BLUE_SHADE_PRIMARY'}
              onPress={onCreateEntityPress}
            />
            <ButtonNew
              height={40}
              width={100}
              title={'Not now'}
              onPress={handleNotNow}
              borderRadius={4}
              borderWidth={1}
              borderColor={'BLUE_SHADE_PRIMARY'}
              color={'WHITE'}
              titleColor={'BLUE_SHADE_PRIMARY'}
              type={'secondarySmall'}
            />
          </ModBox>
        </Box>
        <Spacer size={40} direction={'horizontal'} />
        <Box {...styles.searchContainer}>
          <Text title={'Manage Entity'} fontSize={18} color={'BLACK_21'} fontFamily={'jiotype-bold'} />
          <Spacer direction="vertical" size={16} />
          <ModBox show={entityManageData.length > 0} flexDirection={'row'} flexWrap={'wrap'} w={350}>
            {entityManageData.map((data) => {
              const manageEntityItemPress = () => {
                entityItemPress(data)
              }
              return (
                <Box
                  direction="row"
                  alignItems={'center'}
                  marginBottom={16}
                  w={170}
                  onPress={manageEntityItemPress}
                  underlayColor={'TRANSPARENT45'}>
                  <Text title={data} fontSize={14} color={'#0070B6' as ColorOptions} fontFamily={'jiotype-medium'} />
                  <Icon id={'ARROW_RIGHT'} size={20} color={'#0070B6' as ColorOptions} />
                  <Spacer direction="horizontal" size={16} />
                </Box>
              )
            })}
          </ModBox>
        </Box>
      </Box>
    </Box>
  )
}
export default EntityManagement
